import { h, render } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { Grid, Typography, Box, Paper, } from "@mui/material";

import NotaryCardInvite from "../Common/NotaryCardInvite";

import { AppContext } from "../../AppContext";

export default function InviteNotary({ id, mode }) {

    const [state, setState] = useState({});

    const handleChange = (prop) => (event) => {
        console.log("uuuu", event)
        setState({ ...state, [prop]: event.target.value });
    };

    const app = useContext(AppContext);

    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/0622fe92c03c4297ab3d5c00b0c56047/" + id, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        setState((state) => ({
                            ...state,
                            ...res.pld,
                        }));

                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    }, []);
    console.log("InviteNotary", state)
    return (
        <div style="padding: 20px;">
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Paper style="padding: 10px;">
                        <Typography variant="h5">Inviter son notaire</Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12}>

                    <Paper style="padding: 10px; height: 100%">
                        <NotaryCardInvite updatedState={state} state={state} handleChange={handleChange} popup={false} id={id} />
                    </Paper>

                </Grid>
            </Grid>
        </div>
    );
}
